<template>
  <div
    :style="{
      'padding-top': paddingTop + 'px',
      'padding-bottom': paddingBottom + 'px',
      'background-color': useBackgroundColor
    }"
  >
    <div
      :class="{ 'container': useContainer, 'redirect-block-select': blockParams?.isUrl }"
      @click="$emit('block:redirect')"
    >
      <div
        class="columns columns--cards"
      >
        <div
          v-for="(block, index) in blocksByTag"
          :key="index"
          class="column col-6 sm-col-12"
        >
          <a
            v-if="block.fields.link?.value?.startsWith(['https://'])"
            :href="block.fields.link?.value"
            target="_blank"
            class="box-link"
          >
            <div class="box-link__image">
              <img
                :src="getSvgPath(block.fields.icon?.value)"
                loading="lazy"
              >
            </div>
            <div class="box-link__title">
              {{ block.fields.title?.value }}
            </div>
          </a>
          <nuxt-link
            v-else
            :to="{ path: block.fields.link?.value?.[0] === '/' ? block.fields.link?.value : `/${block.fields.link?.value}` }"
            class="box-link"
          >
            <div class="box-link__image">
              <img
                :src="getSvgPath(block.fields.icon?.value)"
                loading="lazy"
              >
            </div>
            <div class="box-link__title">
              {{ block.fields.title?.value }}
            </div>
          </nuxt-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import staticBlockMixin from '~/mixins/staticBlockMixin'

export default {
  mixins: [staticBlockMixin]
}
</script>
